import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import Loader from '../components/Loader';
import LuxuryCashbackDisplay from '../components/LuxuryCashbackDisplay';
import HeroVideo from '../components/HeroVideo/HeroVideo';
import NewDrop from '../components/NewDrop/NewDrop';
import SignaturePieces from '../components/SignaturePieces/SignaturePieces';
import ElegantAbout from '../components/ElegantAbout/ElegantAbout';
import CollectionsGrid from '../components/CollectionsGrid/CollectionsGrid';
import './NewHomePage.css';

const NewHomePage = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Handle page loading
  useEffect(() => {
    // Minimum loading time for smooth experience
    const minLoadingTime = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTime);
  }, []);

  // SEO and structured data for homepage
  const homePageSEO = {
    title: "Premium Men's Fashion | Custom Tailored Clothing Online",
    description: "Shop premium men's fashion online at Vastré By Vijh (VastreByVijh). Custom tailored suits, designer kurtas, ethnic wear, formal shirts, and premium menswear. Perfect fit guaranteed with personalized measurements. Buy online at vastrebyvijh.com",
    keywords: "vastrebyvijh, VastreByVijh, vastre by vijh, premium men's fashion, online men's clothing, custom tailored suits, designer menswear, ethnic wear online, kurta for men, formal wear online, wedding suits, designer kurta, sherwani, bandhgala, indo western, men's fashion India, premium menswear, tailored clothing online, vastrebyvijh.com",
    image: "https://images.vastrebyvijh.com/vastre-images/home-hero/desktop/2025-08-26/home-hero_desktop_1756239228357_0_1920w.webp",
    url: "https://vastrebyvijh.com/",
    type: "website",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "VastreByVijh",
      "alternateName": ["Vastré By Vijh", "Vastre By Vijh", "vastrebyvijh"],
      "url": "https://vastrebyvijh.com",
      "description": "VastreByVijh - Premium Custom Made Men's Clothing & Bespoke Fashion with Perfect Fit by Vastré By Vijh",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://vastrebyvijh.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  };

  return (
    <>
      <SEOHead {...homePageSEO} />
      
      {/* Main Full-Page Loader */}
      <Loader isLoading={isLoading} />
      
      <div className="newhomepage-wrapper">
        {/* 1. Hero Video Section */}
        <HeroVideo />

        {/* 2. New Drop Section (New Collection Products) */}
        <NewDrop />

        {/* 3. Signature Pieces Section (Featured Products) */}
        <SignaturePieces />

        {/* 4. Elegant About Section (Combined Elegant Couture + About Us) */}
        <ElegantAbout />

        {/* 5. All Collections Grid */}
        <CollectionsGrid />

        {/* Luxury Cashback Floating Icon */}
        <LuxuryCashbackDisplay 
          orderTotal={0} 
          position="bottom-right" 
          showFloatingIcon={true}
          autoOpen={true}
          pageKey="newhome"
        />
      </div>
    </>
  );
};

export default NewHomePage;

